import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import React from 'react';

interface QuestionSkeletonProps {
  hideCard?: boolean;
}

export const QuestionSkeleton = ({ hideCard }: QuestionSkeletonProps) => {
  return (
    <Card className={cn(hideCard && 'border-transparent shadow-none')}>
      <CardContent>
        <div className="flex flex-col gap-4">
          <div className="flex items-center flex-row gap-2">
            <Skeleton className="rounded-full w-8 h-8" />

            <div className="flex flex-col gap-2">
              <Skeleton className="h-3 w-32" />
              <Skeleton className="h-2 w-16" />
            </div>
          </div>

          <Skeleton className="h-4 w-full" />

          <div className="flex items-center  justify-between gap-2">
            <Skeleton className="h-3 w-44" />
            <Skeleton className="h-4 w-36" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
